import { Card } from "./ui/card";

export function Kpi({ label, value, sub, onClick, testId }) {
  return (
    <Card onClick={onClick}
      data-testid={testId}
      className={`p-5 border border-border bg-card hover:border-accent/50 transition-colors ${onClick ? "cursor-pointer" : ""}`}>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className="metric-value text-3xl mt-2">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </Card>
  );
}

export function StatusBadge({ status }) {
  const map = {
    new: "bg-amber-500/10 text-amber-700 border-amber-500/20",
    attempted: "bg-blue-500/10 text-blue-700 border-blue-500/20",
    connected: "bg-blue-500/10 text-blue-700 border-blue-500/20",
    qualified: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
    visit_scheduled: "bg-purple-500/10 text-purple-700 border-purple-500/20",
    visit_completed: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
    negotiation: "bg-indigo-500/10 text-indigo-700 border-indigo-500/20",
    booked: "bg-emerald-600/15 text-emerald-800 border-emerald-600/30 font-semibold",
    lost: "bg-rose-500/10 text-rose-700 border-rose-500/20",
  };
  const cls = map[status] || "bg-secondary text-secondary-foreground border-border";
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium tracking-tight ${cls}`}>{(status || "-").replace(/_/g, " ")}</span>;
}
